export class DurationFormatter {
    constructor(t) {
        this.t = t;
    }
    /**
     * @param {string} rfcStartTime - example 2020-05-16T13:00:00.000+03:00
     * @param {string} rfcEndTime - example 2020-05-16T14:00:00.000+03:00
     * @returns {number} 3600000
     */
    getDurationInMs(rfcStartTime, rfcEndTime) {
        const startDate = new Date(rfcStartTime).getTime();
        const endDate = new Date(rfcEndTime).getTime();
        return Math.abs(endDate - startDate);
    }
    /**
     * @param {number} durationInMs - example 5400000
     * @param {DurationMapperOptions} durationMapperOptions - example { hourUnit: 'duration.units.hours', minuteUnit: 'duration.units.minutes' }
     * @returns {number} example 1 hr 30 min
     */
    formatDurationFromMS(durationInMs, durationMapperOptions) {
        const secondsInMinutes = 60;
        const minutesInHour = 60;
        const dayInHours = 24;
        const msInSecond = 1000;
        const msInMinute = secondsInMinutes * msInSecond;
        const msInHour = minutesInHour * msInMinute;
        const msInDay = dayInHours * msInHour;
        let days;
        if (durationMapperOptions.dayUnit) {
            days = Math.floor(durationInMs / msInDay);
            durationInMs = durationInMs % msInDay;
        }
        const hours = Math.floor(durationInMs / msInHour);
        const minutes = Math.floor((durationInMs / msInMinute) % minutesInHour);
        const dayText = this.t(durationMapperOptions.dayUnit, { days });
        const hourText = this.t(durationMapperOptions.hourUnit, { hours });
        const minuteText = this.t(durationMapperOptions.minuteUnit, { minutes });
        let result = '';
        if (days) {
            result += dayText;
        }
        if (hours) {
            result += ` ${hourText}`;
        }
        if (minutes) {
            result += ` ${minuteText}`;
        }
        return result.trim();
    }
}
//# sourceMappingURL=durationFormatter.js.map